import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormVersionSelectorComponent } from './components/form-version-selector/form-version-selector.component';
import { MultiFormVersionSelectorComponent } from './components/multi-form-version-selector/multi-form-version-selector.component';

export { FormVersionSelectorComponent } from './components/form-version-selector/form-version-selector.component';

@NgModule({
  declarations: [FormVersionSelectorComponent, MultiFormVersionSelectorComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, NgSelectModule],
  exports: [FormVersionSelectorComponent, MultiFormVersionSelectorComponent],
})
export class FormVersionSelectorModule {}
